import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { CollectionItemHeader } from 'components/layout';
import getTheme from '../../theme/theme';
import TraitsSearchBar from './traits/TraitsSearchBar';
import TraitsTable from './traits/TraitsTable';
import CollectionKeys from '../../hooks/molecules/collection-keys';
import { useItems } from '../../hooks/atoms/items-hook';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      minWidth: 275,
    },
    bullet: {
      display: 'inline-block',
      margin: theme.spacing(0, 1),
      transform: 'scale(0.8)',
    },
    title: {
      fontSize: 14,
    },
    pos: {
      marginBottom: theme.spacing(1),
    },
    demo: {
      backgroundColor: '#f0f0f0',
      alignItems: 'center',
      marginLeft: '5%',
      marginRight: '5%',
    },
  };
});

const Traits = () => {
  const {
    items: traits,
    count: totalTraits,
  } = useItems(CollectionKeys.TRAITS);

  const classes = useStyles();

  return (
    <div className={ classes.root }>
      <div style={ { display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: getTheme().spacing(2) } }>
        <CollectionItemHeader
          title='Traits'
          subtitle={ traits !== undefined ? `Entries: ${ totalTraits }` : '' }
          actions={ (
            <>
              <TraitsSearchBar />
            </>
          ) }
        />
      </div>
      <TraitsTable />
    </div>
  );
};
export default Traits;
